<template>
    <!-- 小於lg=>card，大於lg=>table -->
    <div class="mt-4">
        <SkeletonSentence class="w-40" />
        <SkeletonBase :content="1" />
        <div class="lg:hidden pad:grid pad:grid-cols-2 pad:gap-4">
            <SkeletonCardPolicy
                v-for="i in 2"
                :key="i"
                class="sm:max-w-[30rem]"
            />
        </div>

        <SkeletonBase
            class="hidden lg:block"
            :table="2"
        />
    </div>
</template>

<script>
import SkeletonBase from '@/components/skeletons/SkeletonBase.vue';
import SkeletonSentence from '@/components/skeletons/SkeletonSentence.vue';
import SkeletonCardPolicy from '@/components/skeletons/SkeletonCardPolicy.vue';

export default {
    components: {
        SkeletonBase,
        SkeletonCardPolicy,
        SkeletonSentence
    },
};
</script>
